export enum StorageKeysEnum {
  jwt = 'jwt', // need to call app api
  usersJwt = 'usersJwt', // need to call users service api
  i18nextLng = 'i18nextLng',
  clickedURL = 'clickedURL',
  onboarding = 'onboarding',
  username = 'username',
}
